import { BC_TYPE } from '../constant';
import { returnSharedFields } from './shared-fields';

export const advancedFilterFields = ({
  t,
  type,
  categoryOptions = [],
  subCategoryOptions = [],
  blockOptions,
  concreteOptions,
  rsCompanyOptions,
  supplierOptions,
  floorOptions,
  unitOptions
}) => {
  const {
    cate,
    manuDate,
    concreteGrade,
    rsinspectionDate,
    rsCompany,
    castingDate,
    asn,
    deliveryDate,
    batchNo,
    arrivalDate,
    installDate,
    hingeSupplier,
    licensePlateNo,
    GpsDeviceId,
    block,
    internalFinishDate,
    floorNo,
    unit,
    chipFailureSA,
    chipFailureSI,
    subCate,
    serialNo,
    productNo,
    dispose,
    firstCastingDate,
    secondCastingDate,
    waterproofInstallDate
  } = returnSharedFields(t);

  const cateWithOptions = {
    ...cate,
    options: categoryOptions,
    fieldProps: {
      multiple: true
    }
  };
  const companyWithOptions = {
    ...rsCompany,
    options: rsCompanyOptions,
    id: 'RscompanyId',
    fieldProps: {
      multiple: true
    }
  };

  const subCateWithOptions = {
    ...subCate,
    options: subCategoryOptions,
    fieldProps: {
      multiple: true
    }
  };
  const gradeWithOptions = {
    ...concreteGrade,
    options: concreteOptions,
    fieldProps: {
      multiple: true
    }
  };

  const blockWithOptions = {
    ...block,
    options: blockOptions,
    fieldProps: {
      multiple: true
    }
  };

  const floorWithOptions = {
    ...floorNo,
    options: floorOptions,
    fieldProps: {
      multiple: true
    }
  };
  const unitWithOptions = {
    ...unit,
    options: unitOptions,
    fieldProps: { multiple: true }
  };
  const supplierWithOptions = {
    ...hingeSupplier,
    options: supplierOptions,
    id: 'SupplierId',
    fieldProps: { multiple: true }
  };

  const rsinspectionDateRange = {
    ...rsinspectionDate,
    type: 'dateRangePicker'
  };
  const internalFinishDateRange = {
    ...internalFinishDate,
    type: 'dateRangePicker'
  };

  const castingDateRange = {
    ...castingDate,
    type: 'dateRangePicker'
  };

  const deliveryDateRange = {
    ...deliveryDate,
    type: 'dateRangePicker'
  };

  const manuDateRange = {
    ...manuDate,
    type: 'dateRangePicker'
  };

  const arrivalDateRange = {
    ...arrivalDate,
    type: 'dateRangePicker'
  };

  const installDateRange = {
    ...installDate,
    type: 'dateRangePicker'
  };
  const firstCastingDateRange = {
    ...firstCastingDate,
    type: 'dateRangePicker'
  };
  const secondCastingDateRange = {
    ...secondCastingDate,
    type: 'dateRangePicker'
  };
  const waterproofInstallDateRange = {
    ...waterproofInstallDate,
    type: 'dateRangePicker'
  };
  const disposeWithTitle = {
    ...dispose,
    checkboxTitle: t('STATUS')
  };

  // return generalFilterFields;
  switch (type) {
    case BC_TYPE.MIC:
    case BC_TYPE.PCF:
    case BC_TYPE.VPB:
    case BC_TYPE.VPK:
      return [
        // dispose,
        disposeWithTitle,
        cateWithOptions,
        // gradeWithOptions,
        asn,
        productNo,
        manuDateRange,
        companyWithOptions,
        rsinspectionDateRange,
        castingDateRange,
        secondCastingDateRange,
        internalFinishDateRange,
        deliveryDateRange,
        { ...batchNo, label: t('T_PLATE_NO') },
        licensePlateNo,
        // gpsDeviceId,
        arrivalDateRange,
        installDateRange,
        blockWithOptions,
        floorWithOptions,
        unitWithOptions,
        chipFailureSA,
        chipFailureSI
      ];
    case BC_TYPE.ALW:
      return [
        disposeWithTitle,
        cateWithOptions,
        subCateWithOptions,
        supplierWithOptions,
        asn,
        manuDateRange,
        deliveryDateRange,
        batchNo,
        arrivalDateRange,
        installDateRange,
        blockWithOptions,
        floorWithOptions,
        unitWithOptions,
        chipFailureSA,
        chipFailureSI
        // dispose
      ];
    case BC_TYPE.MEG:
    case BC_TYPE.TID:
    case BC_TYPE.STA:
      return [
        disposeWithTitle,
        cateWithOptions,
        asn,
        manuDateRange,
        deliveryDateRange,
        batchNo,
        arrivalDateRange,
        installDateRange,
        blockWithOptions,
        floorWithOptions,
        unitWithOptions,
        chipFailureSA,
        chipFailureSI
        // dispose
      ];

    default:
      return [];
  }
};
